<template>
  <v-card elevation="0" flat tile>
    <v-card-text>
      <v-row justify="space-around">
        <v-col cols="12" md="12">
          <!-- Comments -->
          <v-textarea
            outlined
            v-model="$store.state.display.elevatorForm.elevator.comments"
            :label="$t('common:comment_plural')"
            height="500"
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CommentsTab",
}
</script>
